import { AddAlarmOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function EmptyTimeExtensionHistoryOverlay() {
  return (
    <NoRowsOverlay
      title='ไม่พบผู้เข้าสอบที่มีการทดเวลาสอบ'
      icon={AddAlarmOutlinedIcon}
      slotProps={{
        icon: {
          fontSize: 100,
        },
      }}
    />
  );
}
